package com.zaurh.mapquizwebsite.presentation.screen.home

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.navigation.NavController
import com.zaurh.mapquizmobile.presentation.navigation.Screen
import com.zaurh.mapquizwebsite.presentation.screen.main.MainViewModel
import com.zaurh.mapquizwebsite.presentation.screen.main.components.SignInAlert
import com.zaurh.mapquizwebsite.utils.getOutfitFont
import mapquizwebsite.shared.generated.resources.Res
import mapquizwebsite.shared.generated.resources.mapquiz_cover_dark
import org.jetbrains.compose.resources.painterResource

@Composable
fun HomeScreen() {
    BoxWithConstraints(
        modifier = Modifier
            .fillMaxSize()
            .background(MaterialTheme.colorScheme.background)
    ) {
        val maxWidth = maxWidth

        val headerTextSize = (maxWidth.value * 0.02f)
            .coerceIn(22f, 36f)
            .sp

        val descTextSize = (maxWidth.value * 0.02f)
            .coerceIn(13f, 24f)
            .sp

        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(32.dp)
        ) {
            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(10.dp))
            ) {
                Image(
                    modifier = Modifier.fillMaxWidth(),
                    painter = painterResource(Res.drawable.mapquiz_cover_dark),
                    contentDescription = null,
                    contentScale = ContentScale.Crop
                )

                Column(
                    modifier = Modifier
                        .matchParentSize()
                        .background(
                            brush = Brush.horizontalGradient(
                                colors = listOf(
                                    Color.Black,
                                    Color.Transparent
                                )
                            )
                        )
                        .padding(start = 24.dp),
                    verticalArrangement = Arrangement.Center
                ) {
                    Text(
                        text = "Welcome to MapQuiz",
                        fontFamily = getOutfitFont(),
                        fontWeight = FontWeight.SemiBold,
                        fontSize = headerTextSize,
                        lineHeight = headerTextSize,
                        color = Color.White
                    )

                    Spacer(modifier = Modifier.height(12.dp))

                    Text(
                        text = "Explore MapQuiz for exclusive content, offers, special deals on rare items, and limited-time offers.",
                        fontFamily = getOutfitFont(),
                        fontSize = descTextSize,
                        lineHeight = descTextSize,
                        modifier = Modifier.fillMaxWidth(0.4f),
                        color = Color.White
                    )
                }
            }
        }
    }
}